<template>
  <b-overlay
    :show="isLoading"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่....
        </p>
      </div>
    </template>

    <b-card no-body>
      <b-card-body v-if="form">
        <b-form @submit.prevent="submit">
          <!-- Header -->
          <div class="mb-4 d-flex justify-content-between align-items-center">
            <div>
              <p class="text-danger mb-1">
                ปิด - เปิด อั่งเปา
              </p>
              <b-form-checkbox
                v-model="form.is_enabled"
                class="custom-control-primary"
                name="check-button"
                switch
              >
                <span class="switch-icon-left"><feather-icon icon="CheckIcon" /></span>
                <span class="switch-icon-right"><feather-icon icon="XIcon" /></span>
              </b-form-checkbox>
            </div>

            <div class="d-flex align-items-center">
              <b-button
                variant="success"
                type="submit"
                :disabled="isSaving"
              >
                {{ isSaving ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
              </b-button>
            </div>
          </div>

          <!-- Server errors -->
          <b-alert
            v-if="serverErrors.length"
            show
            variant="danger"
            class="mb-3"
          >
            <div class="font-weight-bold mb-1">
              Validation Error (จาก API)
            </div>
            <ul class="mb-0 pl-3">
              <li
                v-for="(err, i) in serverErrors"
                :key="i"
              >
                {{ err }}
              </li>
            </ul>
          </b-alert>

          <div class="row">
            <!-- Percent range -->
            <div class="col-md-6">
              <b-form-group
                label="ช่วงเปอร์เซ็นต์โบนัส"
                description=""
              >
                <div class="d-flex align-items-center">
                  <b-form-input
                    v-model.number="pctMinUI"
                    type="number"
                    :min="0"
                    :max="100"
                    step="0.01"
                    class="mr-2"
                    required
                  />
                  <span class="mx-2">%</span>
                  <span class="mx-2">—</span>
                  <b-form-input
                    v-model.number="pctMaxUI"
                    type="number"
                    :min="0"
                    :max="100"
                    step="0.01"
                    class="mx-2"
                    required
                  />
                  <span class="ml-2">%</span>
                </div>
                <!-- <small class="text-muted d-block mt-1">
                  จะส่งไปที่ API: pct_min={{ pctMinUI }} , pct_max={{ pctMaxUI }}
                </small> -->
              </b-form-group>
            </div>

            <!-- Min deposit today -->
            <div class="col-md-6">
              <b-form-group label="ยอดฝากขั้นต่ำ ( ยอดขั้นต่ำที่นำไปคำนวณแจกโบนัส )">
                <b-form-input
                  v-model.number="form.min_total_deposit_today"
                  type="number"
                  min="0"
                  required
                />
              </b-form-group>
            </div>

            <!-- Max bonus per user per day -->
            <div class="col-md-6">
              <b-form-group label="ยอดฝากสูงสุด ( ยอดสูงสุดที่นำไปคำนวณแจกโบนัส )">
                <b-form-input
                  v-model.number="form.max_bonus_per_user_per_day"
                  type="number"
                  min="0"
                  required
                />
              </b-form-group>
            </div>

            <!-- Daily total budget -->
            <div class="col-md-6">
              <b-form-group label="งบรวมต่อวัน ( ยอดลิมิตโบนัสที่จะแจก ต่อ วัน )">
                <b-form-input
                  v-model.number="form.daily_total_budget"
                  type="number"
                  min="0"
                  required
                />
              </b-form-group>
            </div>

            <!-- Readonly info -->
            <div class="col-md-6">
              <b-form-group label="งบที่ใช้ไปวันนี้">
                <b-form-input
                  :value="form.budget_used_today"
                  readonly
                />
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="วันที่">
                <b-form-input
                  :value="form.budget_date_key"
                  readonly
                />
              </b-form-group>
            </div>

            <!-- Timezone + Active window -->
            <div class="col-md-6">
              <b-form-group label="Timezone">
                <b-form-input
                  v-model.trim="form.timezone"
                  placeholder="Asia/Bangkok"
                  readonly
                />
              </b-form-group>
            </div>

            <div class="col-md-3">
              <b-form-group label="เวลาเริ่ม (HH:mm)">
                <b-form-input
                  v-model="form.active_start_hhmm"
                  type="time"
                  step="60"
                  required
                />
              </b-form-group>
            </div>

            <div class="col-md-3">
              <b-form-group label="เวลาสิ้นสุด (HH:mm)">
                <b-form-input
                  v-model="form.active_end_hhmm"
                  type="time"
                  step="60"
                  required
                />
              </b-form-group>
            </div>

            <!-- Blacklist only -->
            <div class="col-md-6">
              <b-form-group label="Blacklist (.พิมพ์ username แล้วกด add )">
                <b-form-tags
                  v-if="hasFormTags"
                  v-model="form.blacklist_usernames"
                  separator=",;"
                  remove-on-delete
                  tag-variant="danger"
                  placeholder="พิมพ์แล้วกด Enter หรือ , เพื่อเพิ่ม"
                />
                <b-form-input
                  v-else
                  v-model="blacklistCSV"
                  placeholder="comma separated: user1,user2"
                />
                <!-- <small class="text-muted d-block mt-1">ระบบจะ trim และกันค่าซ้ำให้อัตโนมัติ</small> -->
              </b-form-group>
            </div>
          </div>

          <!-- Footer -->
          <div class="d-flex align-items-center mt-2">
            <!-- <b-button
              variant="success"
              type="submit"
              class="mr-2"
              :disabled="isSaving"
            >
              {{ isSaving ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
            </b-button>

            <b-button
              variant="outline-secondary"
              :disabled="isSaving"
              @click="reset"
            >
              รีเซ็ต
            </b-button> -->

            <div class="ml-auto text-right">
              <div class="small text-muted">
                คงเหลืองบวันนี้ (Remaining): <strong>{{ budgetRemaining | num }}</strong>
              </div>
              <div class="small text-muted">
                ช่วงเวลาใช้งาน:
                <strong>{{ form.active_start_hhmm }} - {{ form.active_end_hhmm }} ({{ form.timezone }})</strong>
              </div>
            </div>
          </div>
        </b-form>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BForm,
  BButton,
  BCard,
  BCardBody,
  BFormGroup,
  BFormInput,
  BOverlay,
  BIconController,
  BFormCheckbox,
  BAlert,
  BFormTags,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BForm,
    BButton,
    BCard,
    BCardBody,
    BFormGroup,
    BFormInput,
    BOverlay,
    BIconController,
    BFormCheckbox,
    BAlert,
    BFormTags,
  },
  directives: { Ripple },
  filters: {
    num(v) {
      return Number(v || 0).toLocaleString()
    },
  },
  data: () => ({
    form: null,
    isLoading: false,
    isSaving: false,
    serverErrors: [],
    pctMinUI: 2,
    pctMaxUI: 5,
    blacklistCSV: '',
  }),
  computed: {
    hasFormTags() {
      return !!this.$options.components.BFormTags
    },
    budgetRemaining() {
      if (!this.form) return 0
      const total = Number(this.form.daily_total_budget || 0)
      const used = Number(this.form.budget_used_today || 0)
      return Math.max(0, total - used)
    },
  },
  mounted() {
    this.getSetting()
  },
  methods: {
    async getSetting() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get('/redenvelope/show')
        this.form = { ...(data?.data || data) }
        this.pctMinUI = Number(this.form.pct_min || 0)
        this.pctMaxUI = Number(this.form.pct_max || 0)
        if (!this.hasFormTags) {
          this.blacklistCSV = (this.form.blacklist_usernames || []).join(',')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    async submit() {
      this.isSaving = true
      this.serverErrors = []

      try {
        const errs = []
        if (!(this.pctMinUI >= 0 && this.pctMinUI <= 100)) errs.push('pct_min must be in [0,100]')
        if (!(this.pctMaxUI >= 0 && this.pctMaxUI <= 100)) errs.push('pct_max must be in [0,100]')
        if (this.pctMinUI > this.pctMaxUI) errs.push('pct_min cannot be greater than pct_max')

        const nonNegKeys = ['min_total_deposit_today', 'max_bonus_per_user_per_day', 'daily_total_budget']
        nonNegKeys.forEach(k => {
          if (Number(this.form[k]) < 0) errs.push(`${k} must be >= 0`)
        })

        const reHHmm = /^([01]\d|2[0-3]):[0-5]\d$/
        if (!reHHmm.test(this.form.active_start_hhmm)) errs.push('active_start_hhmm must be HH:mm')
        if (!reHHmm.test(this.form.active_end_hhmm)) errs.push('active_end_hhmm must be HH:mm')

        if (errs.length) {
          this.serverErrors = errs
          if (this.$bvToast) {
            this.$bvToast.toast('พบข้อผิดพลาดในการกรอกข้อมูล', {
              title: 'Validate',
              variant: 'danger',
              solid: true,
            })
          }
          this.isSaving = false
          return
        }

        const norm = arr => {
          if (!Array.isArray(arr)) return []
          const set = new Set(arr.map(v => String(v || '').trim()).filter(Boolean))
          return Array.from(set)
        }

        let blacklist = this.form.blacklist_usernames
        if (!this.hasFormTags) {
          blacklist = norm(String(this.blacklistCSV || '').split(/[,;]+/))
        } else {
          blacklist = norm(blacklist)
        }

        const patch = {
          is_enabled: !!this.form.is_enabled,
          pct_min: Number(this.pctMinUI),
          pct_max: Number(this.pctMaxUI),
          min_total_deposit_today: Number(this.form.min_total_deposit_today || 0),
          max_bonus_per_user_per_day: Number(this.form.max_bonus_per_user_per_day || 0),
          daily_total_budget: Number(this.form.daily_total_budget || 0),
          timezone: String(this.form.timezone || 'Asia/Bangkok').trim() || 'Asia/Bangkok',
          active_start_hhmm: this.form.active_start_hhmm,
          active_end_hhmm: this.form.active_end_hhmm,
          blacklist_usernames: blacklist,
        }

        const { data } = await this.$http.post('/redenvelope/setting/update', patch)
        const updated = data?.data || data

        if (updated) {
          this.form = { ...updated }
          this.pctMinUI = Number(this.form.pct_min || 0)
          this.pctMaxUI = Number(this.form.pct_max || 0)
          if (!this.hasFormTags) {
            this.blacklistCSV = (this.form.blacklist_usernames || []).join(',')
          }
          await this.$swal({
            icon: 'success',
            title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
            text: 'บันทึกข้อมูลเรียบร้อย',
            customClass: { confirmButton: 'btn btn-success' },
          })
        }
      } catch (error) {
        console.log(error)
        const resp = error?.response?.data
        if (Array.isArray(resp?.errors)) this.serverErrors = resp.errors
        const msg = resp?.message || 'บันทึกไม่สำเร็จ'
        if (this.$bvToast) {
          this.$bvToast.toast(msg, { title: 'Error', variant: 'danger', solid: true })
        }
      } finally {
        this.isSaving = false
      }
    },

    reset() {
      this.getSetting()
      if (this.$bvToast) {
        this.$bvToast.toast('รีเซ็ตข้อมูลจากเซิร์ฟเวอร์แล้ว', {
          title: 'Reset',
          variant: 'info',
          solid: true,
        })
      }
    },
  },
}
</script>
